gsap.registerPlugin(ScrollTrigger);
window.requestAnimationFrame(function() {
  ScrollTrigger.matchMedia({
    "(min-width: 750px)": function() {
        ScrollTrigger.create({
          trigger: ".co-plp-hero-left",
          pin: ".co-plp-hero-left-float",
          start: "top top",
          end: "bottom bottom"
        });
      }
  });
});
// gsap.set(".co-plp-hero .co-ani-o", { opacity: 0 });
// gsap.to(".co-plp-hero .co-ani-o", { 
//   opacity: 1, 
//   duration: 1,
//   stagger: 0.15,
//   ease: "Power1.inOut"
// });
// COMPARISON SLIDER
(function() {
  const section = document.querySelector('.co-plp-s2');
  if (!section) return;

  function initSliders() {
    section.querySelectorAll('[data-comparison]').forEach(function(el) {
      const overlay = el.querySelector('.image-compare-overlay');
      const slider = el.querySelector('.image-compare-slider');
      const overlayImg = overlay.querySelector('img');
      let isResizing = false;
      let currentPct = 50;

      function updateDimensions() {
        var w = el.offsetWidth + 'px';
        if (overlayImg) overlayImg.style.width = w;
        var wrapper = overlay.firstElementChild;
        if (wrapper) wrapper.style.width = w;
      }

      function setPosition(pct) {
        currentPct = Math.max(0, Math.min(pct, 100));
        overlay.style.width = currentPct + '%';
        slider.style.left = currentPct + '%';
        el.setAttribute('aria-valuenow', Math.round(currentPct));
        el.setAttribute('aria-valuetext', Math.round(currentPct) + ' percent, showing ' + Math.round(currentPct) + '% before and ' + Math.round(100 - currentPct) + '% after');
      }

      function updateFromPointer(x) {
        const rect = el.getBoundingClientRect();
        const position = Math.max(0, Math.min(x - rect.left, rect.width));
        setPosition((position / rect.width) * 100);
      }

      function startResize(e) {
        e.preventDefault();
        isResizing = true;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        updateFromPointer(x);

        const move = function(e) {
          if (!isResizing) return;
          updateFromPointer(e.touches ? e.touches[0].clientX : e.clientX);
        };
        const end = function() {
          isResizing = false;
          document.removeEventListener('mousemove', move);
          document.removeEventListener('mouseup', end);
          document.removeEventListener('touchmove', move);
          document.removeEventListener('touchend', end);
        };

        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', end);
        document.addEventListener('touchmove', move);
        document.addEventListener('touchend', end);
      }

      el.addEventListener('keydown', function(e) {
        var step = e.shiftKey ? 10 : 2;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            e.preventDefault();
            setPosition(currentPct - step);
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            e.preventDefault();
            setPosition(currentPct + step);
            break;
          case 'Home':
            e.preventDefault();
            setPosition(0);
            break;
          case 'End':
            e.preventDefault();
            setPosition(100);
            break;
        }
      });

      updateDimensions();
      el.addEventListener('mousedown', startResize);
      el.addEventListener('touchstart', startResize);
      window.addEventListener('resize', updateDimensions);
    });
  }

  function initTabs() {
    const buttons = Array.from(section.querySelectorAll('.co-plp-s2-tab-button'));
    const cells = section.querySelectorAll('.co-plp-s2-tabs-cell');
    const collectionButtons = section.querySelectorAll('.co-plp-s2-collection-button');

    function activateTab(index) {
      buttons.forEach(function(b) {
        b.classList.remove('co-active');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('tabindex', '-1');
      });
      buttons[index].classList.add('co-active');
      buttons[index].setAttribute('aria-selected', 'true');
      buttons[index].setAttribute('tabindex', '0');

      cells.forEach(function(c) { c.classList.remove('co-active'); });
      if (cells[index]) cells[index].classList.add('co-active');

      var text = buttons[index].getAttribute('data-button-text');
      var url = buttons[index].getAttribute('data-url');
      collectionButtons.forEach(function(a) {
        a.textContent = text;
        a.setAttribute('href', url);
      });
    }

    buttons.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        activateTab(i);
      });

      btn.addEventListener('keydown', function(e) {
        var target = i;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            target = i > 0 ? i - 1 : buttons.length - 1;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            target = i < buttons.length - 1 ? i + 1 : 0;
            break;
          case 'Home':
            e.preventDefault();
            target = 0;
            break;
          case 'End':
            e.preventDefault();
            target = buttons.length - 1;
            break;
          default:
            return;
        }
        activateTab(target);
        buttons[target].focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initSliders(); initTabs(); });
  } else {
    initSliders();
    initTabs();
  }
})();
// Comparison
gsap.to(".co-plp-s2-drop-left", {
  scrollTrigger: {
    trigger: ".co-plp-s2",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  top: "-30%",
});
gsap.to(".co-plp-s2-drop-right", {
  scrollTrigger: {
    trigger: ".co-plp-s2",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
  bottom: "-50%",
});
// REVIEWS
let coCollectionSubHeroAni = document.querySelectorAll(
  ".co--collection--reviews--ani"
);
gsap.set(coCollectionSubHeroAni, { opacity: 0 });
gsap.to(coCollectionSubHeroAni, {
  scrollTrigger: {
    trigger: ".co--collection--reviews",
    start: "25% bottom",
    end: "bottom top",
    toggleActions: "play none none reverse",
  },
  duration: 0.75,
  opacity: 1,
  // ease: "power2.inOut",
  stagger: 0.05,
});